import React from 'react';
import { Link } from 'react-router-dom';

const dashboardStyles = {
    container: {
        padding: '20px',
        maxWidth: '1200px',
        margin: '0 auto',
    },
    header: {
        marginBottom: '20px',
        borderBottom: '1px solid #eee',
        paddingBottom: '10px',
    },
    statsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px',
        marginBottom: '30px',
    },
    statCard: {
        flex: '1 1 250px',
        padding: '20px',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    statValue: {
        fontSize: '2.5rem',
        fontWeight: 'bold',
        color: '#0066cc',
        margin: '10px 0',
    },
    statTitle: {
        fontSize: '1rem',
        color: '#666',
        marginBottom: '5px',
    },
    menuContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '20px',
    },
    menuItem: {
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        backgroundColor: '#fff',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        textDecoration: 'none',
        color: '#333',
    },
    menuItemTitle: {
        fontSize: '1.2rem',
        fontWeight: 'bold',
        marginBottom: '10px',
        color: '#333',
    },
    menuItemDesc: {
        fontSize: '0.9rem',
        color: '#666',
    }
};

function DashboardPage() {
    // Data statistik (dummy)
    const stats = [
        { title: 'Total Jamaah', value: '1,250', trend: '+5%' },
        { title: 'Jamaah Aktif', value: '854', trend: '+3%' },
        { title: 'Paket Umroh', value: '15', trend: '0' },
        { title: 'Pembayaran', value: 'Rp 1.2M', trend: '+12%' },
    ];

    // Menu item data
    const menuItems = [
        {
            title: 'Kelola Jamaah',
            description: 'Mengelola data jamaah, tambah, edit, dan lihat detail jamaah',
            path: '/jamaah'
        },
        {
            title: 'Tambah Jamaah Baru',
            description: 'Pendaftaran jamaah baru dengan lengkap',
            path: '/jamaah/tambah'
        },
        {
            title: 'Kelola Paket Umroh',
            description: 'Kelola paket umroh, harga, dan jadwal keberangkatan',
            path: '/paket'
        },
        {
            title: 'Laporan & Analitik',
            description: 'Lihat laporan statistik jamaah dan performance',
            path: '/laporan'
        },
        {
            title: 'Pembayaran',
            description: 'Kelola transaksi dan pembayaran jamaah',
            path: '/pembayaran'
        },
        {
            title: 'Pengaturan',
            description: 'Kelola pengaturan sistem dan pengguna',
            path: '/pengaturan'
        }
    ];

    return (
        <div style={dashboardStyles.container}>
            <div style={dashboardStyles.header}>
                <h1>Dashboard CRM Umroh</h1>
                <p>Selamat datang di sistem manajemen jamaah umroh</p>
            </div>

            <div style={dashboardStyles.statsContainer}>
                {stats.map((stat, index) => (
                    <div key={index} style={dashboardStyles.statCard}>
                        <div style={dashboardStyles.statTitle}>{stat.title}</div>
                        <div style={dashboardStyles.statValue}>{stat.value}</div>
                        <div>{stat.trend}</div>
                    </div>
                ))}
            </div>

            <h2>Menu Utama</h2>
            <div style={dashboardStyles.menuContainer}>
                {menuItems.map((item, index) => (
                    <Link 
                        key={index} 
                        to={item.path} 
                        style={dashboardStyles.menuItem}
                        onMouseOver={(e) => {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                        }}
                    >
                        <div style={dashboardStyles.menuItemTitle}>{item.title}</div>
                        <div style={dashboardStyles.menuItemDesc}>{item.description}</div>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default DashboardPage;